import type { FC } from 'react';
import React from 'react';
import { MDText } from 'i18n-react';
import { isNull } from 'lodash';

import { TEXT_FALLBACK } from 'Components/Account/AccountPage.consts';
import type { VehicleAccountListItem } from 'Types/vehicle';
import { gbpCurrencyFormatter } from 'Utilities/formatters';
import { applyCypressData } from 'Utilities/helpers';

import LocalTexts from '../../BidsAndOffersVehicleList.texts';

import styles from './BidOfferCell.module.scss';

const LocalT = new MDText(LocalTexts);

type BidOfferCellProps = Pick<VehicleAccountListItem, 'userBid'> & { cypressId: string };

const BidOfferCell: FC<BidOfferCellProps> = ({ cypressId, userBid }) => {
	const { maximumBid, type, value } = userBid;
	const valueToRender = type === 'offer' ? value : maximumBid;

	return (
		<div className={styles.bidOfferContainer} {...applyCypressData(cypressId)}>
			<span>
				{!isNull(valueToRender)
					? gbpCurrencyFormatter({ maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(valueToRender)
					: TEXT_FALLBACK}
			</span>
			<span className={styles.bidOfferLabel}>
				{type === 'offer' ? LocalT.translate('cell.bidOfferCell.offer') : LocalT.translate('cell.bidOfferCell.bid')}
			</span>
		</div>
	);
};

export default BidOfferCell;
